module.exports = __webpack_public_path__ + "static/media/oct24-9.b2b21f80.png";